import { push, replace } from 'react-router-redux';

import camelize from 'camelize';

import { resetUser } from 'app/redux/common/actions';
import { AUTHENTICATION_TOKEN_ERROR } from 'app/utils/error';
import { PLATFORMS } from 'app/utils/constants';
import { goToStore } from 'app/utils/device';

const firebase = __CLIENT__ ? require('firebase/app') : null;

const delay = (ms) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });

const authMiddleware = (store) => (next) => async (action) => {
  const {
    firebaseIdToken: _firebaseIdToken,
    platform,
    version,
    accessToken: _accessToken,
  } = store.getState().common;
  const accessToken =
    (action.meta !== undefined && action.meta.accessToken) || _accessToken;
  const firebaseIdToken =
    (action.meta !== undefined && action.meta.firebaseIdToken) ||
    _firebaseIdToken;

  let _platform = platform;
  if (platform === PLATFORMS.ANDROID) {
    _platform = 'aos';
  }

  const xChatiePlatform = _platform ? `${_platform}/${version}` : `web/1.0.0`;

  if (typeof action.payload === 'function') {
    if (__CLIENT__) {
      if (firebase.auth().currentUser) {
        const idToken = await firebase.auth().currentUser.getIdToken();
        const authAction = {
          ...action,
          payload: action.payload({
            headers: {
              Authorization: `FIT ${idToken}`,
              'x-chatie-platform': xChatiePlatform,
            },
          }),
        };
        return next(authAction);
      }
    }

    if (firebaseIdToken) {
      const authAction = {
        ...action,
        payload: action.payload({
          headers: {
            Authorization: `FIT ${firebaseIdToken}`,
            'x-chatie-platform': xChatiePlatform,
          },
        }),
      };
      return next(authAction);
    }

    if (accessToken) {
      const authAction = {
        ...action,
        payload: action.payload({
          headers: {
            Authorization: `JWT ${accessToken}`,
            'x-chatie-platform': xChatiePlatform,
          },
        }),
      };
      return next(authAction);
    }

    const noAuthAction = {
      ...action,
      payload: action.payload({
        headers: {
          'x-chatie-platform': xChatiePlatform,
        },
      }),
    };
    return next(noAuthAction);
  }

  return next(action);
};

const apiErrorHandlerMiddleware = (store) => (next) => (action) => {
  const { payload, skipError } = action;

  if (typeof payload === 'function') {
    const promise = next(action);

    if (skipError) {
      return promise.catch((err) => {
        return Promise.reject(camelize(err.error));
      });
    }

    return promise.catch((err) => {
      if (typeof err.response === 'undefined') {
        return Promise.reject(err);
      }

      const {
        response: {
          result: { code },
        },
        statusCode,
      } = err;
      if (statusCode === 401) {
        const {
          router: { location },
        } = store.getState();
        const encodedNext = location
          ? encodeURIComponent(`${location.pathname}${location.search}`)
          : '';

        store.dispatch(resetUser(true));

        // invalid id token, only in client
        if (
          typeof window !== 'undefined' &&
          code === AUTHENTICATION_TOKEN_ERROR
        ) {
          window.ci.web.data('firebaseIdToken');

          return delay(5000)
            .then(() => {
              const { firebaseIdToken } = store.getState().common;

              return next({
                ...action,
                skipError: true,
                payload: firebaseIdToken
                  ? payload({
                      headers: {
                        Authorization: `FIT ${firebaseIdToken}`,
                      },
                    })
                  : payload(),
              });
            })
            .then((resp) => {
              return resp;
            })
            .catch((_err) => {
              if (location && location.pathname.startsWith('/studio')) {
                store.dispatch(resetUser());
              }
              store.dispatch(
                push(`/signin?next=${encodedNext}`, { canGoBack: true })
              );
            });
        }

        const params = new URLSearchParams(window.location.search);
        const shareType = params.get('share_type');
        const share = params.get('share');
        const shareUid = params.get('uid');
        const { platform } = store.getState().common;

        if ((share == 'true' || shareType === 'app') && platform === null) {
          alert('앱 다운로드 후 감상해주세요.');

          goToStore(
            {
              medium: 'share_middleware',
              source: shareUid,
            },
            true
          );
          return;
        }

        const r = confirm('로그인 후 사용 가능합니다. 로그인 하시겠습니까?');
        if (r) {
          return store.dispatch(
            push(`/signin?next=${encodedNext}`, { canGoBack: true })
          );
        } else {
          return Promise.reject();
        }

        // if (location && location.pathname.startsWith('/studio')) {
        //   store.dispatch(resetUser());
        // } else {
        //   store.dispatch(
        //     push(`/signin?next=${encodedNext}`, { canGoBack: true })
        //   );
        // }
      } else if (statusCode === 404 && !action.noRedirect) {
        // not found
        store.dispatch(replace('/not-found'));
      }

      return Promise.reject(camelize(err.error));
    });
  }

  return next(action);
};

export default {
  authMiddleware,
  apiErrorHandlerMiddleware,
};



// WEBPACK FOOTER //
// ./src/app/redux/middlewares.js